"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GuardianModel = /** @class */ (function () {
    function GuardianModel($http, UserService, APPURL) {
        this.$http = $http;
        this.UserService = UserService;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: this.APPURL + "/api/v1/guardian",
            UPDATE: this.APPURL + "/api/v1/guardian",
            CREATE: this.APPURL + "/api/v1/guardian",
        };
        this.cacheResponse = this.cacheResponse.bind(this);
        this.cacheUsers = this.cacheUsers.bind(this);
        this.cacheSingleUser = this.cacheSingleUser.bind(this);
        this.extract = this.extract.bind(this);
    }
    GuardianModel.prototype.extract = function (result) {
        return result.data;
    };
    GuardianModel.prototype.cacheUsers = function (result) {
        var users = this.extract(result);
        return users;
    };
    GuardianModel.prototype.cacheSingleUser = function (result) {
        var users = this.extract(result);
        return users;
    };
    GuardianModel.prototype.cacheResponse = function (result) {
        return this.extract(result);
    };
    /**
     * User specific model data (admins, owners)
     */
    GuardianModel.prototype.getByID = function (userId) {
        return this.$http
            .get(this.URLS.FETCH + "/" + userId)
            .then(this.cacheSingleUser);
    };
    return GuardianModel;
}());
exports.default = GuardianModel;
